import { type IconDefinition } from '@fortawesome/fontawesome-svg-core'

/**
 * Converts FontAwesome icon object to an compatible inline svg definition
 */
export const getInlineIcon = (faIcon: IconDefinition): string => {
  return `${faIcon.icon[4]}|0 0 ${faIcon.icon[0]} ${faIcon.icon[1]}`
}
